/** @type {IApiConfig} */
const config = {
  production: true,
  region: 'th',
  environment: 'production',
  api: 'https://th-node.dimorder.com/',
  customerApi: 'https://th-customer-api.dimorder.com/',
  deliveryApi: 'https://th-delivery-api.dimorder.com/',
  dimboxApi: 'https://th-box-api.dimorder.com',
  goAdminApi: 'https://th-admin-api.dimorder.com/',
  quickPayApi: 'https://th-quickpaylink-api.dimorder.com/',
  receipt: 'https://th-receipt.dimorder.com/',
  notificationSocketUrl: 'wss://th-admin-api.dimorder.com/a/notification/subscribe',
  clientUrl: 'https://th-dimorder.com',
  clientNewUrl: 'https://th-c.dimorder.com',
  clientWaiterUrl: 'https://th-waiter2.dimorder.com',
  dashboardUrl: 'https://th-dimorder-dashboard.web.app',
  reportUrl: 'https://th-dimorder-report.web.app',
  mpUrl: 'https://th-mp.dimorder.com',
  firebase: {
    apiKey: 'AIzaSyAC2_mmhv1MR6uVsza3btLvR1SKM1XUGBI',
    authDomain: 'dimorder-th.firebaseapp.com',
    databaseURL: 'https://dimorder-th-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'dimorder-th',
    storageBucket: 'dimorder-th.firebasestorage.app',
    messagingSenderId: '209186232433',
    appId: '1:209186232433:web:0a9d74aca09eb7766923d0',
    measurementId: 'G-WGJXJGKGZQ',
  },
}

export default config
